// tslint:disable
export var TCSPaymentType;
(function (TCSPaymentType) {
    // None
    TCSPaymentType[TCSPaymentType["None"] = 0] = "None";
    // Check to Site
    TCSPaymentType[TCSPaymentType["CheckToSite"] = 1] = "CheckToSite";
    // Check to Patient
    TCSPaymentType[TCSPaymentType["CheckToPatient"] = 2] = "CheckToPatient";
    // Debit Card
    TCSPaymentType[TCSPaymentType["DebitCard"] = 3] = "DebitCard";
    // Check Payable to Site
    TCSPaymentType[TCSPaymentType["CheckPayableToSite"] = 4] = "CheckPayableToSite";
    // Electronic Funds Transfer
    TCSPaymentType[TCSPaymentType["ElectricFundsTransfer"] = 5] = "ElectricFundsTransfer";
})(TCSPaymentType || (TCSPaymentType = {}));
TCSPaymentType['NONE'] = 0;
TCSPaymentType['CHECKTOSITE'] = 1;
TCSPaymentType['CHECKTOPATIENT'] = 2;
TCSPaymentType['DEBITCARD'] = 3;
TCSPaymentType['CHECKPAYABLETOSITE'] = 4;
TCSPaymentType['ELECTRICFUNDSTRANSFER'] = 5;
//# sourceMappingURL=TCSPaymentType.js.map